import { X } from 'lucide-react'

interface OnboardingChecklistProps {
  onResume: () => void
  onDismiss: () => void
}

const checklistItems = [
  'Add your first project',
  'Install the feedback widget',
  'Enable monitoring',
]

export function OnboardingChecklist({ onResume, onDismiss }: OnboardingChecklistProps) {
  return (
    <div className="bg-framed-yellow-50/50 border border-framed-yellow-200/60 rounded-xl p-5 mb-6">
      <div className="flex items-start justify-between mb-3">
        <div>
          <h3 className="text-sm font-semibold text-framed-neutral-800">Getting Started</h3>
          <p className="text-xs text-framed-neutral-500 mt-0.5">
            Set up Framed to get the most out of it.
          </p>
        </div>
        <button
          onClick={onDismiss}
          className="p-1 text-framed-neutral-400 hover:text-framed-neutral-600 transition-colors -mt-1 -mr-1"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      <div className="space-y-2 mb-4">
        {checklistItems.map((item) => (
          <div key={item} className="flex items-center gap-2">
            <div className="w-4 h-4 rounded-full border-2 border-framed-neutral-300 flex-shrink-0" />
            <span className="text-sm text-framed-neutral-600">{item}</span>
          </div>
        ))}
      </div>

      <button
        onClick={onResume}
        className="text-sm font-medium text-framed-neutral-800 hover:text-framed-neutral-600 transition-colors"
      >
        Continue setup &rarr;
      </button>
    </div>
  )
}
